export default "__VITE_ASSET__nDV64Pdy__"